import React, { useState } from 'react'
import { Tooltip } from 'reactstrap';
import InfoIcon from "web/assets/svg/InfoIcon"
import { BoxContainer, Heading, InfoDetailWrapper } from '../userInfoStyled';

const InfoBox = ({ heading, children }) => {

    const [tooltip, setTooltip] = useState(false);
    const [tooltipSection, setTooltipSection] = useState('');
    const iIconToolTip = (infoSection, infoTxt) => {
        return <>
            <InfoIcon id={infoSection} style={{ marginLeft: '5px', marginBottom: '5px' }} />
            <Tooltip
                placement="top"
                isOpen={tooltip && tooltipSection === infoSection}
                target={infoSection}
                toggle={() => {
                    setTooltip(!tooltip)
                    setTooltipSection(tooltipSection === '' ? infoSection : '')
                }
                }
                className='info-tooltip-ul'
                style={{
                    maxWidth: "100%",
                    textAlign: "left"
                }}
            >
                <>
                    <p>1. Affiliate commission is calculated on the buyer's fee !</p>
                    <p>2. Internal commission is calculated on the base cost!</p>
                </>
            </Tooltip>
        </>
    }


    return (
        <BoxContainer>
            <Heading>{heading}
                {heading === "Affiliate & Commission Module" && iIconToolTip('AffiliateCommissionModule')}
            </Heading>
            <InfoDetailWrapper className='info-detail-wrapper'>
                {children}
            </InfoDetailWrapper>
        </BoxContainer>
    )
};

export default InfoBox;